import(/* webpackMode: "eager" */ "/vercel/path0/app/confidencials-policies/page.tsx")